import { render } from "./Case.vue?vue&type=template&id=6a8ee5f8&scoped=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"

import "./Case.vue?vue&type=style&index=0&id=6a8ee5f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a8ee5f8"

export default script